import { useState, useContext, useCallback, FC } from 'react';
import { useTranslation } from "react-i18next";
import Popup from '..';
import Table from '../../table';
import { Context } from '../../../context';
import { ITablePopup } from '../popup.types/Tablepopup.type';

const modalName = "TablePopup"

const TablePopup: FC<ITablePopup> = ({ fetchId, apiFunc, columns = [], refModal, onClosePopup, title }) => {
    const { setLoading } = useContext(Context)
    const { t } = useTranslation()
    const [totalRows, setTotalRows] = useState<number>(0)
    const [data, setData] = useState<[]>([])
    const [tableFiller, setTableFiller] = useState({ PageSize: 25, page: 0 })

    const fetchData = useCallback(() => {
        if (!fetchId) return
        setLoading((l: number) => l + 1)
        apiFunc(fetchId, tableFiller).then((result: { data: { data: any, totalCount: number } }) => {
            setData(result.data.data)
            setTotalRows(result.data.totalCount)
            setLoading((l: number) => l - 1)
        }).catch(() => {
            setLoading((l: number) => l - 1)
        })

    }, [fetchId, tableFiller])

    return (
        <>
            <button ref={refModal} data-bs-toggle="modal" data-bs-target={`#${modalName + fetchId}`} hidden></button>

            <Popup onClose={onClosePopup} name={modalName + fetchId} large={true} title={t(title) || ""}>

                <Table
                    columns={columns}
                    data={data}
                    fetchData={fetchData}
                    TotalRows={totalRows}
                    setTableFiller={setTableFiller}
                    tableFiller={tableFiller}
                    askForFetch={true}
                />

                <div className="buttons">
                    <button className="btn btn-outline-success my-2 my-sm-0" onClick={onClosePopup}>
                        <span role="status" aria-hidden="true"></span>
                        {t("Close")}
                    </button>
                </div>
            </Popup >
        </>
    );
}

export default TablePopup;